import { createContext, useContext } from 'react';
import { NOT_LOGGED_IN_USER_ID } from '../constants';
export var configurationContextDefaultValues = {
    baseRoute: '',
    identityUrl: '',
    staticApiUrl: '',
    tenant: '',
    onlineBaseUrl: '',
    userName: '',
    antiForgeryToken: '',
    returnUrl: '',
    allowedPhoneFormats: [],
    availablePasswordRecoveryChannels: [],
    availableTenants: [],
    externalProviders: [],
    externalAccount: {
        loginProvider: '',
        providerKey: ''
    },
    countries: [],
    status: 0,
    globalApiUrl: '',
    clientId: '',
    currentLanguage: '',
    customerId: NOT_LOGGED_IN_USER_ID,
    allowRememberLogin: true,
    defaultRememberLogin: false,
    allowPasswordless: false
};
export var configurationContext = createContext(configurationContextDefaultValues);
export var ConfigurationProvider = configurationContext.Provider;
export var useConfiguration = function() {
    return useContext(configurationContext);
};
